import GeneralLedger from "../general-ledger/general-ledger";

export default function SubsidiaryLedgerS02c1() {
  return <GeneralLedger baseRoute="/templates/subsidiary-ledger" />;
}
